module.exports = __webpack_public_path__ + "static/media/tapan_new_logo.92a98509.jpg";